document.addEventListener("DOMContentLoaded", () => {

    const originalFetch = window.fetch;
    const BUNDLE_DISCOUNT_CODE = "CUSTOMBUNDLE01";
    const BUNDLE_PROPERTY = "_bundle_source";
    const BUNDLE_PROPERTY_VALUE = "custom_bundle";


    /*
     * ============================================================
     * FAST BUNDLE FLAG
     * ============================================================
     *
     * This is set ONLY by Fast Bundle's pre_add_script.
     */

    window.fbNextAddIsBundle = false;


    /*
     * ============================================================
     * GET CART
     * ============================================================
     */

    async function getCart() {

        const response = await originalFetch.call(
            this,
            "/cart.js"
        );

        if (!response.ok) {
            throw new Error(
                `Failed to get cart: ${response.status}`
            );
        }

        return await response.json();
    }


    /*
     * ============================================================
     * APPLY DISCOUNT
     * ============================================================
     */

    async function applyBundleDiscount() {


        const response = await originalFetch.call(
            this,
            "/cart/update.js",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    discount: BUNDLE_DISCOUNT_CODE
                })
            }
        );


        if (!response.ok) {

            console.error(
                "Failed to apply bundle discount:",
                response.status
            );

        } else {

            console.log(
                "Bundle discount applied"
            );

        }


        return response;
    }


    /*
     * ============================================================
     * REMOVE BUNDLE DISCOUNT
     * ============================================================
     */

    async function removeBundleDiscount(cart) {

        const hasBundleDiscount =
            Array.isArray(cart.discount_codes) &&
            cart.discount_codes.some(
                discount =>
                    discount.code?.toUpperCase() ===
                    BUNDLE_DISCOUNT_CODE.toUpperCase()
            );


        if (!hasBundleDiscount) {

            console.log(
                "Coupon is not currently applied"
            );

            return;
        }


        console.log(
            "Removing bundle discount"
        );

        const response = await originalFetch.call(
            this,
            "/cart/update.js",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    discount: ""
                })
            }
        );


        if (!response.ok) {

            console.error(
                "Failed to remove bundle discount:",
                response.status
            );

        } else {

            console.log(
                "Bundle discount removed"
            );

        }


        return response;
    }


    /*
     * ============================================================
     * CHECK WHETHER CART CONTAINS OUR BUNDLE
     * ============================================================
     *
     * We look at the LINE ITEM PROPERTY created by the existing
     * Fast Bundle logic:
     *
     * _bundle_source = custom_bundle
     */

    function cartHasBundle(cart) {

        return cart.items?.some(item => {

            return (
                item.properties?.[BUNDLE_PROPERTY] ===
                BUNDLE_PROPERTY_VALUE
            );

        });
    }


    /*
     * ============================================================
     * ENFORCE BUNDLE DISCOUNT
     * ============================================================
     *
     * RULE:
     *
     * Bundle exists + exactly ONE cart item
     *      → CUSTOMBUNDLE01
     *
     * Bundle exists + MORE THAN ONE cart item
     *      → remove CUSTOMBUNDLE01
     *
     * No bundle
     *      → do nothing
     */

    async function enforceBundleDiscount(normalCartMutation = false) {

        try {

            const cart = await getCart();

            const hasBundle = cartHasBundle(cart);


            console.log(
                "Bundle discount check:",
                {
                    itemCount: cart.item_count,
                    hasBundle,
                    items: cart.items
                }
            );

            if (normalCartMutation) { 
              console.log("Normal cart mutation detected"); 
              await removeBundleDiscount(cart); return; 
            }


            /*
             * ====================================================
             * BUNDLE + EXACTLY ONE ITEM
             * ====================================================
             */

            if (
                hasBundle &&
                cart.item_count === 1
            ) {


                console.log(
                    "One bundle product in cart"
                );

                await applyBundleDiscount();

                return;
            }


            /*
             * ====================================================
             * BUNDLE + MORE THAN ONE ITEM
             * ====================================================
             */

            if (
                hasBundle &&
                cart.item_count > 1
            ) {

                console.log(
                    "Bundle cart has more than one item"
                );

                await removeBundleDiscount(cart);

                return;
            }


            /*
             * ====================================================
             * NO BUNDLE
             * ====================================================
             */

            console.log(
                "No custom bundle detected"
            );

        } catch (error) {

            console.error(
                "Bundle discount enforcement failed:",
                error
            );

        }
    }


    /*
     * ============================================================
     * CART FETCH INTERCEPTOR
     * ============================================================
     */

    window.fetch = async function(resource, options) {

        const url =
            typeof resource === "string"
                ? resource
                : resource?.url;

        console.log("🌐 FETCH", {
        url,
        method: options?.method || "GET",
        body: options?.body
    });



        /*
         * ========================================================
         * CART ADD
         * ========================================================
         */

        if (
            url &&
            url.includes("/cart/add.js") &&
            options?.body
        ) {

            let body;


            try {

                body = JSON.parse(options.body);

            } catch (error) {

                console.warn(
                    "Could not parse /cart/add.js body",
                    error
                );

                return originalFetch.call(
                    this,
                    resource,
                    options
                );
            }


            /*
             * ====================================================
             * FAST BUNDLE ADD
             * ====================================================
             */

            if (window.fbNextAddIsBundle) {

                console.log(
                    "Fast Bundle add detected"
                );


                /*
                 * Add the marker directly to the
                 * cart item(s).
                 */

                if (body.items) {

                    body.items.forEach(item => {

                        item.properties = {
                            ...(item.properties || {}),

                            _bundle_source:
                                BUNDLE_PROPERTY_VALUE
                        };


                        /*
                         * SUBSCRIPTION LOGIC
                         */

                        const supportsSubscription =
                            window.variantSubscriptionSupport?.[
                                item.id
                            ];


                        if (!supportsSubscription) {

                            delete item.selling_plan;

                        }

                    });

                }


                /*
                 * Consume the flag.
                 *
                 * Only this next /cart/add.js request
                 * receives the bundle marker.
                 */

                window.fbNextAddIsBundle = false;


                /*
                 * Replace original request body.
                 */

                options.body = JSON.stringify(body);


                console.log(
                    "Bundle line marked",
                    body
                );

            }


            /*
             * ====================================================
             * NORMAL ADD TO CART
             * ====================================================
             *
             * Do NOT add bundle properties.
             */

            else {

                console.log(
                    "Normal add detected"
                );


                options.body = JSON.stringify(body);
            }


            /*
             * ====================================================
             * LET SHOPIFY ADD THE PRODUCT
             * ====================================================
             */

            const response =
                await originalFetch.call(
                    this,
                    resource,
                    options
                );


            /*
             * Only enforce the discount if this was
             * the Fast Bundle add.
             */

            if (response.ok) {

                await enforceBundleDiscount();

            }


            return response;
        }


        /*
         * ========================================================
         * CART CHANGE / UPDATE
         * ========================================================
         *
         * This catches:
         *
         * - adding/removing products through other cart UI
         * - quantity changes
         * - cart drawer changes
         */

        const isCartMutation =
            url &&
            (
                url.includes("/cart/add") ||
                url.includes("/cart/change")
            );


        if (isCartMutation) {

          console.log("CART MUTATION");

            const response =
                await originalFetch.call(
                    this,
                    resource,
                    options
                );


            if (response.ok) {

                await enforceBundleDiscount(true);

            }


            return response;
        }


        /*
         * ========================================================
         * EVERYTHING ELSE
         * ========================================================
         */

        return originalFetch.call(
            this,
            resource,
            options
        );

    };


    /*
     * ============================================================
     * FAST BUNDLE PRE-ADD HOOK
     * ============================================================
     *
     * PRESERVED FROM YOUR ORIGINAL LOGIC.
     */

    if (!window.FastBundleConf?.bundleBox) {

        console.warn(
            "Fast Bundle configuration not available"
        );

        return;
    }

window.FastBundleConf.bundleBox.pre_add_script = `
(function(processedVariants) {

    /*
     * IMPORTANT:
     *
     * Fast Bundle is executing this function.
     *
     * Therefore the NEXT /cart/add.js request is a
     * Fast Bundle add.
     *
     * This MUST happen BEFORE checking
     * variantSubscriptionSupport.
     *
     * The subscription system and bundle detection are
     * independent from each other.
     */

    window.fbNextAddIsBundle = true;


    console.log(
        "Next cart add marked as Fast Bundle"
    );


    /*
     * If subscription support is not loaded yet,
     * we still keep the Fast Bundle flag above.
     *
     * We simply cannot calculate fbHasSubscriptionVariant
     * at this moment.
     */

    if (!window.variantSubscriptionSupport) {

        console.warn(
            "variantSubscriptionSupport not loaded yet"
        );

        return processedVariants;
    }


    window.fbHasSubscriptionVariant =
        processedVariants.some(function(item) {

            return !!window.variantSubscriptionSupport[
                item.id
            ];

        });


    console.log(
        "Bundle has subscription:",
        window.fbHasSubscriptionVariant
    );


    console.log(
        "processedVariants:",
        processedVariants
    );


    console.log(
        "initialBundle:",
        arguments[1]
    );


    return processedVariants;

})
`;

});